import fetchClient, { ApiResponse } from '@/api/api-client'

import { ApproveCreditServiceReqPayload } from './types/ApproveCreditServiceReqPayload'
import { CreateServiceReqPayload } from './types/CreateServiceReqPayload'
import { GetServiceReqsPayload } from './types/GetServiceReqsPayload'
import { ServiceReq } from './types/ServiceReq'
import { UpdateServiceReqPayload } from './types/UpdateServiceReqPayload'

export async function getServiceReqs(params: GetServiceReqsPayload = {}) {
  const res = await fetchClient.post<ApiResponse<ServiceReq[]>>('/service-reqs/list', params)
  return res.data.data ?? []
}

export async function getServiceReqById(id: string) {
  const res = await fetchClient.get<ApiResponse<ServiceReq>>(`/service-reqs/${id}`)
  return res.data.data
}

export async function createServiceReq(data: CreateServiceReqPayload) {
  const res = await fetchClient.post<ApiResponse<ServiceReq>>('/service-reqs', data)
  if (!res.data.data) {
    throw new Error('Failed to create service request')
  }
  return res.data.data
}

export async function approveServiceReq(id: string, data: ApproveCreditServiceReqPayload) {
  const res = await fetchClient.post<ApiResponse<ServiceReq>>(`/service-reqs/${id}/approve`, data)
  return res.data.data
}

export async function rejectServiceReq(id: string, rejectionReason: string) {
  const res = await fetchClient.post<ApiResponse<ServiceReq>>(`/service-reqs/${id}/reject`, {
    rejectionReason,
  })
  return res.data.data
}

export async function updateServiceReq(id: string, data: Omit<UpdateServiceReqPayload, 'id'>) {
  const res = await fetchClient.patch<ApiResponse<ServiceReq>>(`/service-reqs/${id}`, data)
  if (!res.data.data) {
    throw new Error('Failed to update service request')
  }
  return res.data.data
}

export async function batchUpdateServiceReqReportStatus(ids: string[], reportedToResponsibleParty: boolean) {
  const res = await fetchClient.patch<ApiResponse<ServiceReq[]>>('/service-reqs/report-status', {
    ids,
    reportedToResponsibleParty,
  })
  return res.data.data ?? []
}
